import { defineMessages } from 'react-intl';
import { I18nKeys } from '../../i18n/keys';

export const ProfileMessages = defineMessages({
  myPermissions: {
    id: I18nKeys.MyPermissions,
    defaultMessage: 'My permissions',
  },
  resetPassword: {
    id: I18nKeys.ResetPassword,
    defaultMessage: 'Reset password',
  },
  currentPassword: {
    id: I18nKeys.CurrentPassword,
    defaultMessage: 'Current password',
  },
  currentPasswordIncorrect: {
    id: I18nKeys.CurrentPasswordIncorrect,
    defaultMessage: 'Current password is incorrect',
  },
  newPassword: {
    id: I18nKeys.NewPassword,
    defaultMessage: 'New password',
  },
});
